import React from 'react';
import {
    number,
    object,
    string,
    arrayOf,
    func,
    bool,
    oneOfType,
    shape
} from 'prop-types';
import ToolbarSection from '../toolbar/';
import ListingItemsSection from '../items/';

export default function ListingItemsLayout(props) {
    return (
        <div className="listing-layout">
            <ToolbarSection
                showResultCount={props.showResultCount}
                itemCount={props.itemCount}
                sortBy={props.sortBy}
                currentSort={props.currentSort}
                updateSort={props.updateSort}
                countLabel={props.countLabel}
                keywordFilter={props.keywordFilter}
                activeFilters={props.activeFilters}
                toggleFilters={props.toggleFilters}
                keywordPlaceholderText={props.keywordPlaceholderText}
                isProductFinder={props.isProductFinder}
            />
            <ListingItemsSection
                listingItems={props.listingItems}
                resources={props.resources}
                itemWrapperModifier={props.itemWrapperModifier}
                itemDirection={props.itemDirection}
                itemType={props.itemType}
                totalPages={props.totalPages}
                currentPage={props.currentPage}
                changePage={props.changePage}
                resetFilters={props.resetFilters}
                handleOpenModal={props.handleOpenModal}
                viewMoreText={props.viewMoreText}
                downloadText={props.downloadText}
                meetUsText={props.meetUsText}
                viewProductText={props.viewProductText}
                noDataMessage={props.noDataMessage}
                noDataButtonText={props.noDataButtonText}
                noDataButtonUrl={props.noDataButtonUrl}
                noItemsText={props.noItemsText}
                columnName1={props.columnName1}
                columnName2={props.columnName2}
                columnName3={props.columnName3}
            />
        </div>
    );
}

ListingItemsLayout.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    listingItems: arrayOf(object).isRequired,
    itemCount: number.isRequired,
    itemWrapperModifier: string.isRequired,
    itemType: string.isRequired,
    itemDirection: string.isRequired,
    sortBy: arrayOf(object),
    currentSort: oneOfType([string, object]),
    updateSort: func.isRequired,
    showResultCount: bool,
    totalPages: number.isRequired,
    currentPage: number.isRequired,
    resources: arrayOf(object),
    resetFilters: func.isRequired,
    changePage: func.isRequired,
    handleOpenModal: func.isRequired,
    viewMoreText: string.isRequired,
    downloadText: string.isRequired,
    meetUsText: string.isRequired,
    viewProductText: string.isRequired,
    countLabel: string.isRequired,
    noDataMessage: string.isRequired,
    noDataButtonText: string.isRequired,
    noDataButtonUrl: string.isRequired,
    noItemsText: string.isRequired,
    columnName1: string.isRequired,
    columnName2: string.isRequired,
    columnName3: string.isRequired,
    keywordFilter: shape({
        code: string.isRequired,
        label: string.isRequired,
        values: arrayOf(oneOfType([string, bool, number]))
    }),
    activeFilters: arrayOf(
        shape({
            code: string.isRequired,
            label: string.isRequired,
            values: arrayOf(oneOfType([string, bool, number])).isRequired
        })
    ).isRequired,
    toggleFilters: func.isRequired,
    keywordPlaceholderText: string,
    isProductFinder: bool
    /* eslint-enable react/no-typos */
};

ListingItemsLayout.defaultProps = {
    sortBy: [],
    currentSort: '',
    showResultCount: false,
    resources: []
};
